import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
  ASSIGN_EMPLOYEE,
  BOOKING_DASHBOARD,
  BOOKING_HISTORY,
  CALCULATE_PETTAXI_PRICE,
  CLEAR_ALL_CACHE,
  CLEAR_CART_CACHE,
  CLEAR_DASHBOARD_CACHE,
  CLEAR_HOME_CACHE,
  CLEAR_SEARCH_CACHE,
  CREATE_ADD_ON,
  CREATE_ADMIN_BOOKINGS,
  CREATE_CUSTOMER,
  CREATE_EMPLOYEE,
  CREATE_PACKAGE,
  CREATE_SERVICE,
  CREATE_SERVICE_OFFER,
  DELETE_SERVICE_BY_ID,
  EMAIL_BRANDING_PROFILES,
  EMAIL_TEMPLATE_LOOKUPS,
  EMAIL_TEMPLATE_PREVIEW,
  EMAIL_TEMPLATES,
  GET_ADD_ONS,
  GET_ADD_ONS_BY_ID,
  GET_ADMIN_SETTINGS,
  GET_ALL_PACKAGES,
  GET_ALL_SERVICE,
  GET_BOOKING_DETAILS,
  GET_BOOKINGS,
  GET_DAILY_TIMELINE,
  GET_EMPLOYEE_BY_SERVICE_ID,
  GET_PACKAGE_BY_PACKAGE__ID,
  GET_PACKAGE_BY_SERVICE_ID,
  GET_SERVICE_BY_ID,
  GET_SERVICE_OFFER,
  GET_WORKING_DAY,
  RESCHEDULE_BOOKING,
  SAVE_WORKING_DAY,
  UPDATE_ADD_ON,
  UPDATE_ADD_ON_STATUS,
  UPDATE_BOOKING_DURATION,
  UPDATE_BOOKING_STATUS,
  UPDATE_PACKAGE,
  UPDATE_SERVICE,
  UPDATEADD_ON_SORT_ORDER,
  UPLOAD_EMAIL_BRANDING_PROFILE_LOGO,
  UPLOAD_FILE,
  WEEK_OR_MONTH_TIMELINE,
} from "../../../config/apiUrlsAdmin";
import {
  IAdminCreateCustomerRequest,
  IAdminSettingRequest,
  IAssignEmployeeRequest,
  IBookingFilterRequest,
  ICalculatePetTaxiPriceRequest,
  ICreateAddOnRequest,
  ICreateBookingRequest,
  ICreateEmailBrandingProfileRequest,
  ICreateEmailCategoryRequest,
  ICreateEmailLayoutRequest,
  ICreateEmailTemplateRequest,
  ICreateEmployeeRequest,
  ICreateServiceOfferRequest,
  ICreateServiceRequest,
  IEmailBrandingProfile,
  IEmailCategory,
  IEmailLayout,
  IEmailTemplate,
  IGetBookingDashboard,
  IGetBookingHistoryRequest,
  IGetBookingsForMonthOrWeekRequest,
  IPreviewEmailTemplateRequest,
  IRescheduleBookingRequest,
  IServicePackageRequest,
  IServiceWorkingDaysRequest,
  IUpdateAddOnOrderStatusRequest,
  IUpdateAddOnRequest,
  IUpdateAddOnStatusRequest,
  IUpdateApplicationSettingsRequest,
  IUpdateBookingDurationRequest,
  IUpdateBookingStatusRequest,
  IUpdateEmailBrandingProfileRequest,
  IUpdateEmailCategoryRequest,
  IUpdateEmailLayoutRequest,
  IUploadFileRequest,
} from "../../../types/Request/AdminRequest";
import {
  BookingDashboardResponse,
  BookingDetailsResponse,
  BookingTimelineResponse,
  BookingWeekOrMonthTimelineResponse,
  IAdminSettingsResponse,
  IBookingHistoryResponse,
  ICalculatePetTaxiPriceResponse,
  IEmailTemplateLookupsResponse,
  IEmailTemplatePreviewResponse,
  IGetAddOnsResponse,
  IGetAllPackagesResponse,
  IServiceBookingResponse,
  IServiceEmployee,
  IServiceOfferResponse,
  IServicePackageDetails,
  IserviceResponse,
  IUploadFileResponse,
  ProcessCustomerResponse,
} from "../../../types/Response/AdminResponse";

export const adminServiceAPi = createApi({
  reducerPath: "adminServiceAPi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Services", "ApplicationSettings"],

  endpoints: (builder) => ({
    createService: builder.mutation<boolean, ICreateServiceRequest>({
      query: (data) => ({
        url: CREATE_SERVICE,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    UpdateService: builder.mutation<boolean, ICreateServiceRequest>({
      query: (data) => ({
        url: UPDATE_SERVICE,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    GetAllService: builder.query<IserviceResponse[], void>({
      query: () => ({
        url: GET_ALL_SERVICE,
        method: "get",
      }),
      providesTags: ["Services"], // Listens for invalidations
    }),
    GetServiceById: builder.query<IserviceResponse, number>({
      query: (id) => ({
        url: `${GET_SERVICE_BY_ID}/${id}`,
        method: "get",
      }),
      providesTags: ["Services"], // Listens for invalidations
    }),
    DeleteServiceById: builder.query<boolean, number>({
      query: (id) => ({
        url: `${DELETE_SERVICE_BY_ID}/${id}`,
        method: "delete",
      }),
      providesTags: ["Services"], // Listens for invalidations
    }),

    createPackage: builder.mutation<boolean, IServicePackageRequest>({
      query: (data) => ({
        url: CREATE_PACKAGE,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    UpdatePackage: builder.mutation<boolean, IServicePackageRequest>({
      query: (data) => ({
        url: UPDATE_PACKAGE,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    GetPackageByServiceId: builder.query<IServicePackageDetails[], number>({
      query: (id) => ({
        url: `${GET_PACKAGE_BY_SERVICE_ID}/${id}`,
        method: "get",
      }),
      providesTags: ["Services"], // Listens for invalidations
    }),
    GetPackageByPackageId: builder.query<IserviceResponse, number>({
      query: (id) => ({
        url: `${GET_PACKAGE_BY_PACKAGE__ID}/${id}`,
        method: "get",
      }),
      providesTags: ["Services"], // Listens for invalidations
    }),
    GetWorkingDayByServiceId: builder.query<IserviceResponse, number>({
      query: (id) => ({
        url: `${GET_WORKING_DAY}/${id}`,
        method: "get",
      }),
      providesTags: ["Services"], // Listens for invalidations
    }),
    SaveWorkingDay: builder.mutation<boolean, IServiceWorkingDaysRequest>({
      query: (data) => ({
        url: SAVE_WORKING_DAY,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    GetBookings: builder.query<IServiceBookingResponse, IBookingFilterRequest>({
      query: (payload) => ({
        url: GET_BOOKINGS,
        method: "get",
        data: payload,
      }),
      providesTags: ["Services"],
    }),
    UpdateBookingStatus: builder.mutation<boolean, IUpdateBookingStatusRequest>(
      {
        query: (data) => ({
          url: UPDATE_BOOKING_STATUS,
          method: "put",
          data: data,
        }),
        invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
      },
    ),
    CreateServiceOffer: builder.mutation<boolean, ICreateServiceOfferRequest>({
      query: (data) => ({
        url: CREATE_SERVICE_OFFER,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    GetServiceOffer: builder.query<
      IServiceOfferResponse[],
      {
        serviceId: number;
        startDate: string;
        endDate: string;
      }
    >({
      query: ({ serviceId, startDate, endDate }) => ({
        url:
          `${GET_SERVICE_OFFER}` +
          `?serviceId=${serviceId}` +
          `&startDate=${startDate}` +
          `&endDate=${endDate}`,

        method: "get",
      }),

      providesTags: ["Services"],
    }),
    getAllPackages: builder.query<IGetAllPackagesResponse[], void>({
      query: () => ({
        url: `${GET_ALL_PACKAGES}`,
        method: "get",
      }),
    }),

    uploadFile: builder.mutation<IUploadFileResponse, IUploadFileRequest>({
      query: (data) => {
        const formData = new FormData();
        formData.append("file", data.File);
        formData.append("folderName", data.FolderName);
        return {
          url: UPLOAD_FILE,
          method: "post",
          data: formData,
        };
      },
    }),
    createAddOn: builder.mutation<boolean, ICreateAddOnRequest>({
      query: (data) => ({
        url: CREATE_ADD_ON,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    getAddOnsByPackageId: builder.query<IGetAddOnsResponse[], number>({
      query: (servicePackageId) => ({
        url: `${GET_ADD_ONS}/${servicePackageId}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),
    updateAddOnStatus: builder.mutation<boolean, IUpdateAddOnStatusRequest>({
      query: (data) => ({
        url: UPDATE_ADD_ON_STATUS,
        method: "patch",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    updateAddOnOrderStatus: builder.mutation<
      boolean,
      IUpdateAddOnOrderStatusRequest[]
    >({
      query: (data) => ({
        url: UPDATEADD_ON_SORT_ORDER,
        method: "patch",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    getAddOnsById: builder.query<IGetAddOnsResponse, number>({
      query: (id) => ({
        url: `${GET_ADD_ONS_BY_ID}/${id}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),
    updateAddOnCard: builder.mutation<boolean, IUpdateAddOnRequest>({
      query: (data) => ({
        url: UPDATE_ADD_ON,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),

    createBooking: builder.mutation<boolean, ICreateBookingRequest>({
      query: (data) => ({
        url: CREATE_ADMIN_BOOKINGS,
        method: "post",
        data,
      }),
      invalidatesTags: ["Services"],
    }),
    rescheduleBooking: builder.mutation<boolean, IRescheduleBookingRequest>({
      query: (data) => ({
        url: RESCHEDULE_BOOKING,
        method: "put",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    updateDuration: builder.mutation<boolean, IUpdateBookingDurationRequest>({
      query: (data) => ({
        url: UPDATE_BOOKING_DURATION,
        method: "put",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    getBookingDetailsById: builder.query<BookingDetailsResponse, number>({
      query: (bookingId) => ({
        url: `${GET_BOOKING_DETAILS}/${bookingId}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    getDailyTimeline: builder.query<
      BookingTimelineResponse,
      { ServiceId: number; bookingDate: string }
    >({
      query: ({ ServiceId, bookingDate }) => ({
        url: `${GET_DAILY_TIMELINE}?ServiceId=${ServiceId}&BookingDate=${bookingDate}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    getWeekOrMonthTimeline: builder.query<
      BookingWeekOrMonthTimelineResponse,
      IGetBookingsForMonthOrWeekRequest
    >({
      query: (data) => ({
        url: WEEK_OR_MONTH_TIMELINE,
        method: "get",
        data: data,
      }),
      providesTags: ["Services"],
    }),

    getBookingHistory: builder.query<
      IBookingHistoryResponse,
      IGetBookingHistoryRequest
    >({
      query: (data) => ({
        url: BOOKING_HISTORY,
        method: "get",
        data: data,
      }),
      providesTags: ["Services"],
    }),

    CalculatePetTaxiPrice: builder.mutation<
      ICalculatePetTaxiPriceResponse,
      ICalculatePetTaxiPriceRequest
    >({
      query: (data) => ({
        url: CALCULATE_PETTAXI_PRICE,
        method: "post",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    assignEmployee: builder.mutation<boolean, IAssignEmployeeRequest>({
      query: (data) => ({
        url: ASSIGN_EMPLOYEE,
        method: "put",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    getBookingDashboard: builder.query<
      BookingDashboardResponse,
      IGetBookingDashboard
    >({
      query: (data) => ({
        url: BOOKING_DASHBOARD,
        method: "get",
        data: data,
      }),
      providesTags: ["Services"],
    }),

    createCustomer: builder.mutation<
      ProcessCustomerResponse,
      IAdminCreateCustomerRequest
    >({
      query: (data) => ({
        url: CREATE_CUSTOMER,
        method: "post",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    ////  employeee sections

    createEmployee: builder.mutation<boolean, ICreateEmployeeRequest>({
      query: (data) => ({
        url: CREATE_EMPLOYEE,
        method: "post",
        data,
      }),
      invalidatesTags: ["Services"],
    }),
    updateEmployee: builder.mutation<boolean, ICreateEmployeeRequest>({
      query: (data) => ({
        url: CREATE_EMPLOYEE,
        method: "put",
        data,
      }),
      invalidatesTags: ["Services"],
    }),
    getEmployee: builder.query<IServiceEmployee[], void>({
      query: () => ({
        url: CREATE_EMPLOYEE,
        method: "get",
      }),
      providesTags: ["Services"],
    }),
    getEmployeeById: builder.query<IServiceEmployee, number>({
      query: (employeeId) => ({
        url: `${CREATE_EMPLOYEE}/${employeeId}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),
    getEmployeeByServiceId: builder.query<IServiceEmployee[], number>({
      query: (serviceId) => ({
        url: `${GET_EMPLOYEE_BY_SERVICE_ID}/${serviceId}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    GetAdminSettings: builder.query<IAdminSettingsResponse, void>({
      query: () => ({
        url: GET_ADMIN_SETTINGS,
        method: "get",
      }),
      providesTags: ["ApplicationSettings"],
    }),

    UpdateAdminSetting: builder.mutation<
      boolean,
      {
        key: string;
        data: IAdminSettingRequest;
      }
    >({
      query: ({ key, data }) => ({
        url: `${GET_ADMIN_SETTINGS}/${key}`,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Services"], // Invalidates cache to trigger refetch
    }),
    //--------------------------------------------------
    // Bulk Update Application Settings
    //--------------------------------------------------

    getEmailTemplates: builder.query<IEmailTemplate[], void>({
      query: () => ({
        url: EMAIL_TEMPLATES,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    getEmailTemplateById: builder.query<IEmailTemplate, number>({
      query: (id) => ({
        url: `${EMAIL_TEMPLATES}/${id}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    createEmailTemplate: builder.mutation<boolean, ICreateEmailTemplateRequest>(
      {
        query: (data) => ({
          url: EMAIL_TEMPLATES,
          method: "post",
          data,
        }),
        invalidatesTags: ["Services"],
      },
    ),

    updateEmailTemplate: builder.mutation<
      boolean,
      {
        id: number;
        data: ICreateEmailTemplateRequest;
      }
    >({
      query: ({ id, data }) => ({
        url: `${EMAIL_TEMPLATES}/${id}`,
        method: "put",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    deleteEmailTemplate: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `${EMAIL_TEMPLATES}/${id}`,
        method: "delete",
      }),
      invalidatesTags: ["Services"],
    }),

    previewEmailTemplate: builder.mutation<
      IEmailTemplatePreviewResponse,
      IPreviewEmailTemplateRequest
    >({
      query: (data) => ({
        url: EMAIL_TEMPLATE_PREVIEW,
        method: "post",
        data,
      }),
    }),
    UpdateAdminSettings: builder.mutation<
      boolean,
      IUpdateApplicationSettingsRequest
    >({
      query: (data) => ({
        url: GET_ADMIN_SETTINGS,
        method: "put",
        data,
      }),

      invalidatesTags: ["ApplicationSettings"],
    }),

    // --------------------------------------------------
    // Email Branding Profiles
    // --------------------------------------------------

    getEmailBrandingProfiles: builder.query<IEmailBrandingProfile[], void>({
      query: () => ({
        url: EMAIL_BRANDING_PROFILES,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    getEmailBrandingProfileById: builder.query<IEmailBrandingProfile, number>({
      query: (id) => ({
        url: `${EMAIL_BRANDING_PROFILES}/${id}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    createEmailBrandingProfile: builder.mutation<
      IEmailBrandingProfile,
      ICreateEmailBrandingProfileRequest
    >({
      query: (data) => ({
        url: EMAIL_BRANDING_PROFILES,
        method: "post",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    updateEmailBrandingProfile: builder.mutation<
      boolean,
      {
        id: number;
        data: IUpdateEmailBrandingProfileRequest;
      }
    >({
      query: ({ id, data }) => ({
        url: `${EMAIL_BRANDING_PROFILES}/${id}`,
        method: "put",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    setDefaultEmailBrandingProfile: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `${EMAIL_BRANDING_PROFILES}/${id}/set-default`,
        method: "put",
      }),
      invalidatesTags: ["Services"],
    }),

    deleteEmailBrandingProfile: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `${EMAIL_BRANDING_PROFILES}/${id}`,
        method: "delete",
      }),
      invalidatesTags: ["Services"],
    }),

    //--------------------------------------------------
    // Clear Cache
    //--------------------------------------------------

    ClearCache: builder.mutation<boolean, string>({
      query: (url) => ({
        url,
        method: "post",
      }),
    }),

    getEmailTemplateLookups: builder.query<IEmailTemplateLookupsResponse, void>(
      {
        query: () => ({
          url: EMAIL_TEMPLATE_LOOKUPS,
          method: "get",
        }),
      },
    ),

    uploadEmailBrandingProfileLogo: builder.mutation<
      { fileUrl: string },
      FormData
    >({
      query: (formData) => ({
        url: UPLOAD_EMAIL_BRANDING_PROFILE_LOGO,
        method: "post",
        data: formData,
      }),
    }),

    // --------------------------------------------------
    // EMAIL LAYOUTS
    // --------------------------------------------------

    getEmailLayouts: builder.query<IEmailLayout[], void>({
      query: () => ({
        url: `${EMAIL_TEMPLATE_LOOKUPS}/../layouts`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    getEmailLayoutById: builder.query<IEmailLayout, number>({
      query: (id) => ({
        url: `${EMAIL_TEMPLATE_LOOKUPS}/../layouts/${id}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    createEmailLayout: builder.mutation<
      IEmailLayout,
      ICreateEmailLayoutRequest
    >({
      query: (data) => ({
        url: `${EMAIL_TEMPLATE_LOOKUPS}/../layouts`,
        method: "post",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    updateEmailLayout: builder.mutation<
      boolean,
      {
        id: number;
        data: IUpdateEmailLayoutRequest;
      }
    >({
      query: ({ id, data }) => ({
        url: `${EMAIL_TEMPLATE_LOOKUPS}/../layouts/${id}`,
        method: "put",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    setDefaultEmailLayout: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `${EMAIL_TEMPLATE_LOOKUPS}/../layouts/${id}/set-default`,
        method: "put",
      }),
      invalidatesTags: ["Services"],
    }),

    deleteEmailLayout: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `${EMAIL_TEMPLATE_LOOKUPS}/../layouts/${id}`,
        method: "delete",
      }),
      invalidatesTags: ["Services"],
    }),

    // --------------------------------------------------
    // EMAIL CATEGORIES
    // --------------------------------------------------

    getEmailCategories: builder.query<IEmailCategory[], void>({
      query: () => ({
        url: `${EMAIL_TEMPLATES}/categories`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    getEmailCategoryById: builder.query<IEmailCategory, number>({
      query: (id) => ({
        url: `${EMAIL_TEMPLATES}/categories/${id}`,
        method: "get",
      }),
      providesTags: ["Services"],
    }),

    createEmailCategory: builder.mutation<
      IEmailCategory,
      ICreateEmailCategoryRequest
    >({
      query: (data) => ({
        url: `${EMAIL_TEMPLATES}/categories`,
        method: "post",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    updateEmailCategory: builder.mutation<
      boolean,
      {
        id: number;
        data: IUpdateEmailCategoryRequest;
      }
    >({
      query: ({ id, data }) => ({
        url: `${EMAIL_TEMPLATES}/categories/${id}`,
        method: "put",
        data,
      }),
      invalidatesTags: ["Services"],
    }),

    deleteEmailCategory: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `${EMAIL_TEMPLATES}/categories/${id}`,
        method: "delete",
      }),
      invalidatesTags: ["Services"],
    }),
  }),
});

export const {
  useCreateServiceMutation,
  useUpdateServiceMutation,
  useLazyGetAllServiceQuery,
  useLazyGetServiceByIdQuery,
  useLazyDeleteServiceByIdQuery,

  useCreatePackageMutation,
  useUpdatePackageMutation,
  useLazyGetPackageByPackageIdQuery,
  useLazyGetPackageByServiceIdQuery,

  useSaveWorkingDayMutation,
  useLazyGetWorkingDayByServiceIdQuery,
  useLazyGetBookingsQuery,
  useUpdateBookingStatusMutation,

  useCreateServiceOfferMutation,
  useLazyGetServiceOfferQuery,
  useGetAllPackagesQuery,

  useUploadFileMutation,
  useCreateAddOnMutation,
  useLazyGetAddOnsByPackageIdQuery,
  useUpdateAddOnStatusMutation,
  useUpdateAddOnOrderStatusMutation,
  useGetAddOnsByIdQuery,
  useUpdateAddOnCardMutation,
  useCreateBookingMutation,
  useGetAdminSettingsQuery,
  useUpdateAdminSettingMutation,
  useLazyGetBookingDashboardQuery,
  useLazyGetBookingHistoryQuery,
  useLazyGetBookingDetailsByIdQuery,
  useLazyGetDailyTimelineQuery,
  useLazyGetWeekOrMonthTimelineQuery,
  useAssignEmployeeMutation,
  useUpdateDurationMutation,
  useRescheduleBookingMutation,

  useCreateCustomerMutation,
  useCreateEmployeeMutation,
  useUpdateEmployeeMutation,
  useLazyGetEmployeeByIdQuery,
  useLazyGetEmployeeByServiceIdQuery,
  useLazyGetEmployeeQuery,
  useLazyGetEmailTemplatesQuery,
  useLazyGetEmailTemplateByIdQuery,
  useCreateEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useDeleteEmailTemplateMutation,
  usePreviewEmailTemplateMutation,
  useLazyGetEmailBrandingProfilesQuery,
  useLazyGetEmailBrandingProfileByIdQuery,
  useCreateEmailBrandingProfileMutation,
  useUpdateEmailBrandingProfileMutation,
  useSetDefaultEmailBrandingProfileMutation,
  useDeleteEmailBrandingProfileMutation,
  useUploadEmailBrandingProfileLogoMutation,
  useClearCacheMutation,
  useUpdateAdminSettingsMutation,
  useCalculatePetTaxiPriceMutation,
  useLazyGetEmailTemplateLookupsQuery,
  useLazyGetEmailLayoutsQuery,
  useLazyGetEmailLayoutByIdQuery,
  useCreateEmailLayoutMutation,
  useUpdateEmailLayoutMutation,
  useSetDefaultEmailLayoutMutation,
  useDeleteEmailLayoutMutation,
  useLazyGetEmailCategoriesQuery,
  useLazyGetEmailCategoryByIdQuery,
  useCreateEmailCategoryMutation,
  useUpdateEmailCategoryMutation,
  useDeleteEmailCategoryMutation,
} = adminServiceAPi;
